module.exports = __webpack_public_path__ + "img/2m.95f26e5f.jpg";